import { DateTime } from 'luxon';

// The Remediation KPI row's activity tiles cover a single day: the viewer's
// local calendar day. Current-state tiles (Job Sites, Equipment) ignore it.
//
// The window start is sent to the backend as an instant. Same contract as
// getAssignmentKpis' today_start: the server can't know the viewer's timezone,
// so the client always states the boundary.
export const dayStart = (): string => DateTime.local().startOf('day').toUTC().toISO() as string;

// IANA zone name (e.g. America/Los_Angeles) so the backend can bucket activity
// into the viewer's calendar days. Falls back to UTC if the browser won't
// report a zone.
export const viewerTimeZone = (): string => DateTime.local().zoneName ?? 'UTC';
